/** Text shown in the quantity field. Zero is a real value; only missing or NaN values render empty. */
export function formatQuantityValue(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return ''
  return String(value)
}
